module.exports = "/_next/static/images/recommendations-2412195121439edec928c58fe3a55489.png";